import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { ClickEventListener } from '@philips-emr/tws-core/lib/component/types';

export default class HpmsTermServiceApi extends ComponentAPI<any> {

  @AwesomeEvent
  onSubmitTermUse = new ClickEventListener();

  setCheckBoxExpression(expression: string): void {
    this.setState({ checkBoxExpression: expression });
  }

  setEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  setData(data: string): void {
    this.setState({ data });
  }

  setChecked(check: boolean): void {
    this.setState({ check });
  }

  isChecked(): boolean {
    return this.state.check;
  }
}
